// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__c+6wk","separator":"footer_separator__oYZo-"};